export const getSendVerificationCodeUrl = () => '/send_code';
export const getVerificationCodeUrl = () => '/verify_code';
